import {
  PARTNER_LOGIN_SUCCESS,
  PARTNER_LOGIN_FAILED,
  RESET_PARTNER_LOGIN,
  LOADING_PARTNER_LOGIN,
  NETWORK_ERROR_PARTNER_LOGIN,
} from "../types/index";
import isEmpty from "../../validation/is-empty";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  isAvailable: false,
  failed: false,
  isError: false,
  isLocked: false,
  status: "",
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_PARTNER_LOGIN:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        isAvailable: false,
        isError: false,
        isLocked: false,
        data: {},
        message: "",
        networkError: "",
      };
    case PARTNER_LOGIN_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        isAvailable: false,
        isError: false,
        isLocked: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case PARTNER_LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        isAvailable: !isEmpty(action.payload),
        isError: false,
        isLocked: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_PARTNER_LOGIN:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: false,
        isAvailable: false,
        isError: false,
        isLocked: false,
        data: {},
        message: "Network Error",
        networkError: "",
      };
    case RESET_PARTNER_LOGIN:
      return (state = initialState);
    default:
      return state;
  }
};
